import AddIcon from "@mui/icons-material/Add";
import { Fab } from "@mui/material";

const FloatAddButton = (props: { onClick: () => void }) => (
  <Fab
    color="primary"
    aria-label="add"
    onClick={() => props.onClick()}
    sx={{
      position: "fixed",
      bottom: { xxs: 24, md: 40 },
      right: { xxs: 24, md: 40 },
    }}
  >
    <AddIcon />
  </Fab>
);

export default FloatAddButton;
